import * as Zod from 'zod';

export const ticketPriorityScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
